<template>
  <modal
    class="modal--tbl-settings"
    title="edit table settings"
    v-if="show"
    :activate="show"
    @activate="closeModal"
  >
    <template slot="body">
      <div class="form-con">
        <div
          class="form-items"
          v-for="col in allCols"
          :key="col.value"
        >
          <checkbox>
            <input
              type="checkbox"
              v-model="modConfig.tableConfig[tblSetting]"
              :value="col.value"
            />
          </checkbox>
          <span>{{ col.display }}</span>
        </div>
      </div>
    </template>

    <template slot="footer">
      <button
        class="btn--modify -withlabel"
        @click="modify"
      >
        <i class="ico--save"></i>
        <span>modify</span>
      </button>
    </template>
  </modal>
</template>

<script>
import { mapMutations } from 'vuex'

//= jquery
import $ from 'jquery'

//= components
import Checkbox from '@/components/base/Checkbox'
import Modal from '@/components/base/Modal'

export default {
  name: 'table-settings',

  props: {
    activate: Boolean,
    showTblSettings: Boolean,
    allCols: [String, Array, Object],
    tblSetting: [String, Array, Object]
  },

  components: {
    Checkbox,
    Modal
  },

  data () {
    return {
      isDraggable: false,
      show: false,

      headerClass: '',
      title_w: '',
      toolbar_w: 'auto',

      modalBody: 'auto'
    }
  },

  watch: {
    activate () {
      if (this.activate) {
        this.modalActive()
      }

      if (!this.activate) {
        this.closeModal()
      }
    }, // activate

    config: {
      handler () {
        if (this.config[this.tblSetting]) {
          this.$emit('input', this.config[this.tblSetting])
        }
      },
      deep: true
    }
  },

  mounted () {
    this.show = this.showTblSettings

    if (this.activate) {
      this.modalActive()
    }
  },

  methods: {
    ...mapMutations('config', { setConfig: 'SET_CONFIG' }),

    modify () {
      this.updateConfig()
      this.closeModal()
      this.$emit('load')
    },

    modalActive () {
      let keys = Object.keys(this.modConfig.tableConfig)
      if (!keys.length || keys.indexOf(this.tblSetting) === -1) {
        let copy = Object.assign({}, this.modConfig)

        let cols = this.allCols.map((e) => {
          return e.value
        })

        copy.tableConfig[this.tblSetting] = cols
        this.setConfig(copy)
      }

      this.show = true
    }, // modalActive

    closeModal () {
      this.show = false
      this.$emit('activate', this.show)
      $('body').removeAttr('style')
      $('body').removeClass('modal--open')
    } // closeModal
  }
}
</script>

<style scoped>
  .check-wrap { margin-right: 10px; }
  label {
    display: inline-block;
  }
</style>
